import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { CenterState } from './states'

const AdsAccount: Module<CenterState, State> = {
  state: new CenterState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default AdsAccount
